<template>
	<section class="container container_main-content">
		<h1 class="heading heading-title">{{ $t('contact') }}</h1>
		<div class="icon__divider">
			<span class="icon icon__divider-outer">
				<span class="icon icon__divider-inner"></span>
			</span>
		</div>
		<article class="contact-page__section contact-page__section-main">
			<div class="text-box centered">
				<p class="text-box-bottom content-default">
					Najdeš nás v Černovicích, z centra i kanceláře jsi u nás do 10 minut.<br />Parkování před vchodem a zastávka za rohem.
				</p>
				<address class="contact-details content-box-primary content-box-primary-bold flex-horizontal">
					<div class="contact-details__item flex-horizontal">
						<img class="contact-details__icon contact-details__icon-address" src="" alt="" />
						<div class="address">
							<a class="contact-details__link address__link" :href="address.href" target="blank">
								<div class="address__line">
									<span class="address__street">
										{{ address.street }}
									</span>
									<span class="address__divider">,</span>
								</div>
								<div class="address_line">
									<span class="address__zip">{{ address.zip }}</span
									><span class="address__divider"> - </span><span class="address__city-extended">{{ address.city }}</span>
								</div>
							</a>
						</div>
					</div>
					<div class="contact-details__item flex-horizontal">
						<img class="contact-details__icon contact-details__icon-phone" src="" alt="" />
						<a class="contact-details__link" :href="phoneHref">{{ phone }}</a>
					</div>
					<div class="contact-details__item flex-horizontal">
						<img class="contact-details__icon contact-details__icon-email" src="" alt="" />
						<div class="flex-vertical">
							<a class="contact-details__link" :href="emailHref">{{ email }}</a>
							<span class="contact-details__note">email neslouží pro rezervace</span>
						</div>
					</div>
				</address>
				<div class="opening-hours__wrapper text-box flex-vertical">
					<div class="opening-hours__text opening-hours__text-primary content-box-primary content-box-primary-bold">
						<span class="opening-hours__status">{{ $t('opening_hours') }}</span>
					</div>
					<div class="opening-hours__text opening-hours__text-secondary">
						<div
							class="opening-hours__hours content-box-primary content-box-primary-bold flex-horizontal"
							v-for="(day, i) in days"
							:key="i"
						>
							<span> {{ $moment().day(day.dayOfWeek).format('ddd') }}: </span>
							<span><span></span>{{ day.openingHours }}<span>h</span></span>
						</div>
					</div>
				</div>
			</div>
		</article>
		<article class="contact-page__section contact-page__section-map flex-vertical">
			<div class="contact__map">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2607.5792374328857!2d16.641959751580778!3d49.18957037921984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471294dd682f51b1%3A0x2bc4e20f52926186!2sTurgen%C4%9Bvova%2011%2C%20618%2000%20Brno-%C4%8Cernovice!5e0!3m2!1sen!2scz!4v1593183457536!5m2!1sen!2scz"
					width="100%"
					height="100%"
					frameborder="0"
					style="border: 0;"
					allowfullscreen=""
					aria-hidden="false"
					tabindex="0"
				></iframe>
			</div>

			<div class="contact__social flex-horizontal">
				<div class="contact__social-item">
					<a class="social-icon social-icon__fb-small" :href="$cfg('social.fb')" target="blank"></a>
				</div>
				<div class="contact__social-item">
					<a class="social-icon social-icon__ig-small" :href="$cfg('social.ig')" target="blank"></a>
				</div>
			</div>
		</article>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			address: 'app/address',
			phone: 'app/phone',
			phoneHref: 'app/phoneHref',
			openingHours: 'app/openingHours',
			emailHref: 'app/emailHref',
			email: 'app/email',
		}),
	},

	data() {
		return {
			days: [],
		}
	},

	async created() {
		let { data } = await this.$http.get('/opnhr')
		this.days = data
	},
}
</script>
